import { render, staticRenderFns } from "./GestioneUtenti.vue?vue&type=template&id=5b182c50&"
import script from "./GestioneUtenti.vue?vue&type=script&lang=js&"
export * from "./GestioneUtenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports